/**
 * Course scoping — one rule for the whole CRM.
 *
 * Non-admin staff only work with the courses they created (B2B: each client
 * sees their own catalogue). Account admins see everything the backend
 * returns — /courses/admin is already tenant-scoped server-side — so an
 * admin never lands on an "empty CRM" because courses were authored by
 * teachers or other staff.
 */
const ADMIN_ROLES = new Set(['ADMIN', 'SUPERADMIN', 'SUPER_ADMIN']);

export function isAccountAdmin(user) {
  return ADMIN_ROLES.has(String(user?.role || '').toUpperCase());
}

export function scopeCoursesToUser(courses, user) {
  const list = Array.isArray(courses) ? courses : [];
  if (!user?.id || isAccountAdmin(user)) return list;
  return list.filter((c) => c.createdById === user.id);
}
